import { createFileRoute } from "@tanstack/react-router";
import NicaAntier from "@/pages/NicaAntier";
import { loadResultsSummary } from "@/lib/results-seo";

export const Route = createFileRoute("/nica-antier")({
  loader: ({ context }) => loadResultsSummary(context.queryClient, 2),
  head: ({ loaderData }) => {
    const s = loaderData ?? { dateLabel: "", tica: "", nica: "" };
    const title = `Nica Antier ${s.dateLabel}${s.nica ? `: ${s.nica}` : ""} | Diaria Loto Nicaragua`;
    const description = `Resultados Diaria Loto Nicaragua antier ${s.dateLabel}: ${s.nica || "sorteos de 11am, 3pm y 9pm (6pm fines de semana)"}. Con MultiX y dígito final.`;
    return {
      meta: [
        { title },
        { name: "description", content: description },
        { property: "og:title", content: title },
        { property: "og:description", content: description },
        { property: "og:type", content: "website" },
        { property: "og:url", content: "https://tiemposhoy.com/nica-antier" },
        { name: "twitter:card", content: "summary" },
      ],
      links: [{ rel: "canonical", href: "https://tiemposhoy.com/nica-antier" }],
    };
  },
  component: NicaAntier,
});
